/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { curry } from 'ramda';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';

// eslint-disable-next-line import/prefer-default-export
export const renderInput = curry(({ label, loading, maxLength, value }, params) => (
  <TextField
    {...params}
    label={label}
    slotProps={{
      htmlInput: { ...params.inputProps, maxLength },

      input: {
        ...params.InputProps,
        endAdornment: (
          <>
            {loading ? (
              <CircularProgress size={20} sx={{ color: 'secondary.main' }} />
            ) : !value ? (
              <SearchIcon color="inherit" size={20} />
            ) : null}
            {params.InputProps.endAdornment}
          </>
        ),
      },
    }}
  />
));
